"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function init(store) {
    for (var _i = 0, _a = store.state.steps; _i < _a.length; _i++) {
        var step = _a[_i];
        if (step.stepConfig.initHook) {
            step.stepConfig.initHook(store);
        }
    }
}
exports.init = init;
// convenience alias for now to set a step to completed. use this if you want to change the route
// perform some checks and redirect if necessary 
// VM any is a vue component (this) object because we need the router to make the route change
// Setting Vue as type does not seem to work for plugins
function goForward(store, vm) {
    if (!vm || !vm.$router || !vm.$route) {
        throw new Error('You need to provide your component so we can use the router');
    }
    var step = store.getters['currentStep'];
    if (store.getters['valid'](step.name)) {
        store.commit('setStepCompleted', step.name);
    }
    var nextStep = store.getters['currentNext'];
    // look for a previous invalid step so we jump to that
    for (var _i = 0, _a = store.state.steps; _i < _a.length; _i++) {
        var storeStep = _a[_i];
        if (storeStep.name === nextStep.name) {
            break;
        }
        if (!store.getters['valid'](storeStep.name) || !storeStep.completed) {
            nextStep = storeStep;
            break;
        }
    }
    vm.$router.push({ name: nextStep.name, params: vm.$route.params });
}
exports.goForward = goForward;
function resetStore(store) {
    store.commit('RESET_STATE');
}
exports.resetStore = resetStore;
// export everything compliant to the vuex specification for actions
exports.default = {
    init: init, goForward: goForward,
    resetStore: resetStore
};
//# sourceMappingURL=actions.js.map